import Action from "@/action/Action"
import ActionId from "@/action/ActionId"
import AcceptOfferAction from "@/action/actions/AcceptOfferAction"
import SelectPaymentPlanAction from "@/action/actions/SelectPaymentPlanAction"
import ApplyResponseCode from "@/model/apply/ApplyResponseCode"
import type { PendingReason } from "@/model/apply/PendingReason"
import { applyService } from "@/service"
import { applicationState, providerState, sessionState } from "@/state"
import router from "@/router"

const COMPLETE_VIA_EXTERNAL_URL = "complete_via_external_url" as PendingReason

class ResolvePayMonthlyRouteAction extends Action {
    refreshPendingStatus: boolean

    constructor({ refreshPendingStatus = false }: { refreshPendingStatus?: boolean } = {}) {
        super(ActionId.RESOLVE_PAY_MONTHLY_ROUTE)
        this.refreshPendingStatus = refreshPendingStatus
    }

    async invoke(): Promise<void> {
        if (this.refreshPendingStatus) {
            return this.resolvePendingStatusRoute()
        } else {
            return this.resolveInitialRoute()
        }
    }

    async resolveInitialRoute(): Promise<void> {
        const plan = applicationState.selectedPaymentPlan

        // Reuse an existing apply response when resuming; otherwise create one.
        let applyResponse = providerState.applyResponse

        if (!applyResponse) {
            await new SelectPaymentPlanAction(plan, applicationState.application.purchaseAmountCents, false).invoke()

            const acceptOfferResponse = await new AcceptOfferAction(
                sessionState.providerKey,
                applicationState.application
            ).invoke()

            applyResponse = acceptOfferResponse?.provider
        }

        if (!applyResponse || applyResponse.responseCode === ApplyResponseCode.ERROR) {
            await router.push(`/providers/${sessionState.providerKey}/error`)
            return
        }

        if (
            applyResponse.applyUrl ||
            applyResponse.pendingReasons?.some(reason => reason === COMPLETE_VIA_EXTERNAL_URL)
        ) {
            await router.push(`/providers/${sessionState.providerKey}/payMonthlyIframe`)
            return
        }

        if (applyResponse.responseCode === ApplyResponseCode.DECLINED) {
            await router.push(`/providers/${sessionState.providerKey}/payMonthlyDeclined`)
            return
        }

        if (applyResponse.responseCode === ApplyResponseCode.PENDING) {
            await router.push(`/providers/${sessionState.providerKey}/payMonthlyPending`)
            return
        }

        await router.push(`/providers/${sessionState.providerKey}/error`)
    }

    async resolvePendingStatusRoute(): Promise<void> {
        const iFrameResponse = await applyService.getIframeUrl(sessionState.providerKey)

        if (iFrameResponse.applicationStatus === ApplyResponseCode.APPROVED) {
            providerState.setApplyResponse(sessionState.providerKey, {
                applyUrl: iFrameResponse.url,
                ...providerState.applyResponse,
            })
            await router.push(`/providers/${sessionState.providerKey}/payMonthlyIframe`)
            return
        }

        if (iFrameResponse.applicationStatus === ApplyResponseCode.DECLINED) {
            await router.push(`/providers/${sessionState.providerKey}/payMonthlyDeclined`)
            return
        }

        if (iFrameResponse.applicationStatus === ApplyResponseCode.PENDING) {
            await router.push(`/providers/${sessionState.providerKey}/payMonthlyPending`)
            return
        }

        await router.push(`/providers/${sessionState.providerKey}/error`)
    }
}

export default ResolvePayMonthlyRouteAction


